// @flow
import type {AppliedFacets, FacetList, FacetOption} from "./types";

import qs from 'querystring';

const parseFacetOrderQuery = (queryString: string): Array<string> =>
  // reversed so that options not in facetOrder param are ordered last while sorting
  (qs.parse(queryString).facetOrder || '').split(',').reverse() ?? [];

const addFacetName = (appliedFacets: AppliedFacets) =>
  (facetName: string): Array<FacetOption> => (Array.isArray(appliedFacets[facetName]) ? appliedFacets[facetName].map(facet => Object.assign(facet, {facetName})) : []);

const facetParam = ({facetName = '', id = ''}: FacetOption): string => (
  facetName === 'price' ? facetName : `${facetName}:${id}`
);

const orderAppliedFacets = (facetOrder: Array<string>) =>
  (a: FacetOption, b: FacetOption) => facetOrder.indexOf(facetParam(b)) - facetOrder.indexOf(facetParam(a));

const getOrderedFacetsFromUrl = (appliedFacets: AppliedFacets, queryString: string): FacetList => {
  const facetOrder = parseFacetOrderQuery(queryString);
  return Object.keys(appliedFacets)
    .map(addFacetName(appliedFacets))
    // $FlowFixMe [our version of flow does not support flat func for Arrays]
    .flat()
    .sort(orderAppliedFacets(facetOrder))
};

export default getOrderedFacetsFromUrl;
